<template>
  <div class="esop-overview">
    <div class="cards-grid">
      <div
        class="stat-card"
        v-for="(card, index) in cards"
        :key="index"
      >
        <div class="card-header">
          <div class="icon-wrapper" :class="`icon-${index}`">
            <svg v-if="card.title === 'Allocated shares'" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M17.5 12.5V17.5H2.5V12.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M10 13.75V2.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M5 7.5L10 2.5L15 7.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            <svg v-if="card.title === 'Market price'" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M10 1.66667V18.3333" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M14.1667 4.16667H7.91667C7.14312 4.16667 6.40125 4.47396 5.85427 5.02094C5.30729 5.56793 5 6.30979 5 7.08333C5 7.85688 5.30729 8.59874 5.85427 9.14573C6.40125 9.69271 7.14312 10 7.91667 10H12.0833C12.8569 10 13.5987 10.3073 14.1457 10.8543C14.6927 11.4013 15 12.1431 15 12.9167C15 13.6902 14.6927 14.4321 14.1457 14.9791C13.5987 15.526 12.8569 15.8333 12.0833 15.8333H5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            <svg v-if="card.title === 'Total shares vested'" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M17.5 10H15L12.5 17.5L7.5 2.5L5 10H2.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            <svg v-if="card.title === 'Exercised shares'" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M16.6667 5L7.5 14.1667L3.33333 10" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
          <span class="card-label">{{ card.title }}</span>
        </div>
        <div class="card-body">
          <h3 v-if="details" class="card-value">
            {{ card?.mainValue }}
          </h3>
          <div class="card-meta">
            <span class="meta-label">{{ card.subTitle }}</span>
            <span v-if="details" class="meta-value" :class="{ 'is-percentage': card.title === 'Exercised shares' }">
              {{ card.title === 'Exercised shares' ? `${card?.subValue}%` : card?.subValue }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { convertToLocale, formatAmountToDollar } from "@/utils/helpers.js";
export default {
  name: "EsopOverviewCard",

  data() {
    return {
      date: "",
      details: {},
      cards: [
        {
          title: "Allocated shares",
          mainValue: "",
          subTitle: "Total shares: ",
          subValue: "",
        },
        {
          title: "Market price",
          mainValue: "",
          subTitle: "Average strike price: ",
          subValue: "",
        },
        {
          title: "Total shares vested",
          mainValue: "",
          subTitle: "As of today: ",
          subValue: "",
        },
        {
          title: "Exercised shares",
          mainValue: "",
          subTitle: "of total allocated vested",
          subValue: "",
        },
      ],
    };
  },

  computed: {
    ...mapGetters("Esop", ["esoOverview", "esopToken"]),
  },

  mounted() {
    this.formatDate();
    this.setCardValue();
  },

  methods: {
    formatAmountToDollar,
    setCardValue() {
      this.details = this.esoOverview?.employeeStockOverview[0];
      this.cards[0].mainValue = convertToLocale(
        Number(this.details?.totalAllocatedShares)
      );
      this.cards[0].subValue = convertToLocale(
        Number(this.details?.totalShares || 0)
      );
      this.cards[1].mainValue = formatAmountToDollar(
        this.esopToken?.valuation / this.esopToken?.total_supply,
        2,
        "USD"
      );
      this.cards[1].subValue = formatAmountToDollar(
        this.details?.averageStrikePrice,
        2,
        "USD"
      );
      this.cards[2].mainValue = convertToLocale(
        Number(this.details?.totalSharesVested)
      );
      this.cards[2].subValue = this.date;
      this.cards[3].mainValue = convertToLocale(
        Number(this.details?.totalSharesExercised)
      );
      if (this.details?.totalSharesVested === 0) {
        return (this.cards[3].subValue = 0);
      }
      this.cards[3].subValue = (
        (this.details?.totalSharesVested / this.details?.totalAllocatedShares) *
        100
      ).toFixed(2);
    },

    formatDate() {
      let currentDate = new Date().toString().split(" ");
      this.date = currentDate[1] + " " + currentDate[2] + " " + currentDate[3];
    },
  },

  watch: {
    esoOverview(newValue, oldValue) {
      deep: true;
      immediate: true;
      if (newValue !== oldValue) {
        this.setCardValue();
      }
    },
    esopToken(newValue, oldValue) {
      deep: true;
      immediate: true;
      if (newValue !== oldValue) {
        this.setCardValue();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.esop-overview {
  width: 100%;
}

.cards-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 16px;

  @media screen and (min-width: 640px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media screen and (min-width: 1024px) {
    grid-template-columns: repeat(4, 1fr);
  }
}

.stat-card {
  background: white;
  border-radius: 12px;
  border: 1px solid #E2E8F0;
  padding: 18px;
  transition: all 0.2s ease;

  &:hover {
    border-color: #CBD5E1;
    box-shadow: 0 4px 12px rgba(15, 23, 42, 0.06);
  }
}

.card-header {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 14px;
}

.icon-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 38px;
  height: 38px;
  border-radius: 8px;
  flex-shrink: 0;

  &.icon-0 {
    background: #EEF2FF;
    color: #4D84FF;
  }

  &.icon-1 {
    background: #FEF3C7;
    color: #D97706;
  }

  &.icon-2 {
    background: #ECFDF5;
    color: #059669;
  }

  &.icon-3 {
    background: #F0FDF4;
    color: #16A34A;
  }
}

.card-label {
  font-family: 'DM Sans', sans-serif;
  font-size: 13px;
  font-weight: 500;
  color: #64748B;
  white-space: nowrap;
}

.card-body {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.card-value {
  font-family: 'DM Sans', sans-serif;
  font-size: 24px;
  font-weight: 500;
  color: #0F172A;
  margin: 0;
  line-height: 1.2;
}

.card-meta {
  display: flex;
  align-items: center;
  gap: 4px;
  flex-wrap: wrap;
}

.meta-label {
  font-family: 'DM Sans', sans-serif;
  font-size: 13px;
  color: #64748B;
}

.meta-value {
  font-family: 'DM Sans', sans-serif;
  font-size: 13px;
  font-weight: 500;
  color: #4D84FF;

  &.is-percentage {
    background: #EEF2FF;
    padding: 2px 8px;
    border-radius: 20px;
  }
}
</style>
